export const TAX_PLANNING_TYPES: Array<any> = [{name: '1040'}, {name: '1120'}, {name: '1120s'}, {name: '1065'}, {name: 'Sch C'}, {name: 'Sch E'},
  {name: 'Sch F'}, {name: '1041'}, {name: '990'}, {name: 'Other'}];
